import { Observable, Subscriber } from 'rxjs'
import { HttpResponse, IHttpRestClient } from "./IHttpRestClient";
import axios, { AxiosResponse } from 'axios';
import { sessionStorageInstance } from '../storage/Storage';
import { AuthService } from '../authentication/AuthService';
/*
 * Implementation of REST client. This is private and exported only interface to call methods
 */
class HttpRestClient implements IHttpRestClient {
    private axiosInstance = axios.create();
    constructor() {
        // Set interceptor for authentication on axios instance
        this.axiosInstance.interceptors.request.use((request) => {
            let accessToken = sessionStorageInstance.getData('a');
            request.headers = {
                "Authorization": `Bearer ${accessToken}`
            }

            return request;
        });
    }

    get(url: string, params?: object): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.get(url, {
                headers: {
                    "Content-Type": "application/json",
                },
                params: params
            }).then((response) => {
                if (response.status === 200) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] GET Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] GET Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }

    post(url: string, data?: any): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.post(url, data, {
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] POST Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] POST Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }

    put(url: string, data?: any): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.put(url, data, {
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] PUT Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] PUT Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }

    delete(url: string, params?: object): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.delete(url, {
                params: params
            }).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] DELETE Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] DELETE Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }

    patch(url: string, data?: any): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.patch(url, data, {
                headers: {
                    "Content-Type": "application/json",
                }
            }).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] PATCH Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] PATCH Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }

    options(url: string): Observable<HttpResponse> {
        return Observable.create((subscriber: Subscriber<HttpResponse>) => {
            this.axiosInstance.options(url).then((response) => {
                if (response.status === 200 || response.status === 201) {
                    subscriber.next(new HttpResponse(response.status, response.statusText, response.data));
                } else {
                    subscriber.error(new HttpResponse(response.status, response.statusText));
                }
            }).catch((error) => {
                let errorResponse: AxiosResponse = error.response;
                if (errorResponse !== undefined) {
                    console.log("[HttpRestClient] OPTIONS Response status is: " + errorResponse.status + " " + errorResponse.statusText);
                    let httpResponse = new HttpResponse(errorResponse.status, errorResponse.statusText);
                    httpResponse.error = error;
                    httpResponse.data = error.response.data;
                    subscriber.error(httpResponse);
                    if (errorResponse.status === 401) {
                        AuthService.getInstance().notifyUserUnauthenticated();
                    }
                } else {
                    console.log("[HttpRestClient] OPTIONS Response Generic Error");
                    let httpResponse = new HttpResponse(-1000, "Generic error");
                    httpResponse.error = error;
                    subscriber.error(httpResponse);
                }
            }).finally(() => {
                subscriber.complete();
            });
        });
    }
}

export const httpRestClient = new HttpRestClient();